var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMenu && _vm.showLockedIndication)?_c('LockedStepByMenu',{attrs:{"lockedCollaboratorName":_vm.lockedConnectionOwner}}):(_vm.showLockedIndication)?_c('LockedStepBy',{attrs:{"lockedCollaboratorName":_vm.lockedConnectionOwner}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }